import {Stack, Typography} from '@mui/material'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import MainBtn from '../customTable/MainBtn'
import {getOldestUnpaidDaysPastDue} from './getOldestUnpaidDaysPastDue'

type Props = {
  rows: any[]
  isPayingAll: boolean
  isWhishEnabled: boolean
  canPay: boolean
  onPayNow: () => void
}

export default function ServiceFeesWarningBanner({
  rows,
  isPayingAll,
  isWhishEnabled,
  canPay,
  onPayNow,
}: Props) {
  const {t} = useTranslation()
  const daysPastDue = useMemo(() => getOldestUnpaidDaysPastDue(rows), [rows])

  const shouldShow = daysPastDue !== null && daysPastDue >= 25 && daysPastDue < 30
  if (!shouldShow) {
    return null
  }

  const daysUntilSuspend = 30 - daysPastDue

  return (
    <Stack
      mb='16px'
      direction={{xs: 'column', sm: 'row'}}
      alignItems={{xs: 'stretch', sm: 'center'}}
      justifyContent='space-between'
      gap='12px'
      p='16px 20px'
      bgcolor='#FFF7ED'
      border='1px solid #F97316'
      borderRadius='8px'
    >
      <Typography color='#9A3412' fontSize='15px' fontWeight={600}>
        {t('service_fees_suspend_warning', {days: daysUntilSuspend})}
      </Typography>
      {canPay && isWhishEnabled && (
        <MainBtn
          width='auto'
          bgcolor='var(--orange-color)'
          text='service_fees_pay_now'
          isLoading={isPayingAll}
          handelSubmit={onPayNow}
        />
      )}
    </Stack>
  )
}
